import { handleAuthorization, handleOkResponseJson, handleBadRequest400, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';
import { normalizeTextUppercase, normalizeItemsUppercase, normalizeItemsNullableIntegerFields } from '../utils'

export default {
	obterRequisicoesAsync,
	obterMetricasAsync,
	editarRequisicaoAsync,
	enviarRequisicaoAsync,
	inativarRequisicaoAsync,
	aprovarRequisicaoAsync,
	obterRequisicoesBaixaAsync,
	baixarRequisicaoAsync,
	getPdf,
	downloadLista,
	downloadListaBaixa
}

const normalizeProdutosPayload = (produtos) => normalizeItemsNullableIntegerFields(
	normalizeItemsUppercase(produtos, ["observacao"]),
	["prazo"]
);
export const obterRequisicoesAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/Requisicao/obterLista`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterMetricasAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/Requisicao/metricas`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const obterRequisicoesBaixaAsync = async () => {
	const requestOptions = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
	};
	return fetch(`${process.env.VUE_APP_API_URL}/Requisicao/obterListaBaixada`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarRequisicaoAsync = async (prioridade, idUnidadeAdm, idLocal, observacao, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ prioridade, idUnidadeAdm, idLocal, observacao: normalizeTextUppercase(observacao), produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao`, requestOptions);
}

export const editarRequisicaoAsync = async (id,idUnidadeAdm, idLocal, observacao, prioridade, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, idUnidadeAdm, idLocal, observacao: normalizeTextUppercase(observacao), prioridade, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/atualizar`, requestOptions);
}

export const inativarRequisicaoAsync = async (id, justificativa) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, justificativa })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/inativar`, requestOptions);
}

export const aprovarRequisicaoAsync = async (id, observacaoAutorizador, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/aprovar`, requestOptions);
}

export const desautorizarRequisicaoAsync = async (id, observacaoAutorizador, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/desautorizar`, requestOptions);
}

export const baixarRequisicaoAsync = async (id, observacaoAutorizador, unidadeAdm, idUnidadeAdm, status, local, idLocal, prioridade, data, produtos) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador, unidadeAdm, idUnidadeAdm, status, local, idLocal, prioridade, data, produtos: normalizeProdutosPayload(produtos) })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/baixar`, requestOptions);
}

export const declinarRequisicaoAsync = async (id, observacaoAutorizador) => {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		body: JSON.stringify({ id, observacaoAutorizador })
	};
	return apiFetch(`${process.env.VUE_APP_API_URL}/Requisicao/declinar`, requestOptions);
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Requisicao/downloadRequisicoes`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'requisicoes' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export function downloadListaBaixa() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Requisicao/downloadRequisicoesBaixadas`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'requisicoes' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}

export function getPdf(id, janelaPdf = null) {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Requisicao/downloadPdf/` + id,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}

export function getPdfBaixa(id, janelaPdf = null) {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Requisicao/downloadPdf/` + id,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			fecharJanelaPdf(janelaPdf);
			return { status: false };
		})
			.then((response) => {
				if (response.status === false) {
					fecharJanelaPdf(janelaPdf);
					return response;
				}
				abrirBlobPdf(response.data, janelaPdf);
			});
	} catch (e) {
		fecharJanelaPdf(janelaPdf);
		throw e;
	}
}
